import { render, staticRenderFns } from "./AfSelect.vue?vue&type=template&id=10fd810b"
import script from "./AfSelect.vue?vue&type=script&lang=js"
export * from "./AfSelect.vue?vue&type=script&lang=js"
import style0 from "./AfSelect.vue?vue&type=style&index=0&id=10fd810b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports